// The open text box and the words typed into it — a new stamp, or an existing
// stamp being rewritten. Held beside the marks rather than in the drawing
// surface, so a save can see what's typed.

import { useState } from 'react';

export interface ITextBox {
  /** Position and width, in % of the content rect. */
  x: number;
  y: number;
  w: number;
  /** Set when rewriting an existing stamp: its index on the current page. */
  editIndex?: number;
}

export function useTextBox() {
  const [box, setBox] = useState<ITextBox | null>(null);
  const [value, setValue] = useState('');

  function open(next: ITextBox, initialValue = '') {
    setBox(next);
    setValue(initialValue);
  }

  function close() {
    setBox(null);
    setValue('');
  }

  return { box, value, setValue, open, close };
}

export type TextBoxState = ReturnType<typeof useTextBox>;
